<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="back-to-matriculas"
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'matriculas' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Matricula
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        id="matricula-form"
        @submit.prevent="handleSubmit(submitForm)"
        :disabled="submittingForm"
      >
        <v-row v-for="(matricula, index) in form.matriculas" :key="index">
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Aluno" rules="required" v-slot="{ errors }">
              <e-label id="aluno-label">Aluno</e-label>
              <e-autocomplete
                id="aluno-autocomplete"
                :items="alunosDisponiveis(index)"
                :return-object="false"
                :item-value="(aluno) => aluno.id"
                :item-text="
                  (aluno) => {
                    return `${aluno.nomecompleto} (CPF: ${aluno.cpf ?? '- - -'})  `;
                  }
                "
                :loading="carregandoAlunos"
                :readonly="editing"
                v-model="matricula.aluno_id"
                label="Selecione uma opção"
                :error-messages="errors"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
              <e-label id="turma-label">Turma</e-label>
              <e-autocomplete
                id="turma-autocomplete"
                :items="turmasList"
                :return-object="true"
                :item-text="(turma) => turma.descricao"
                :loading="carregandoTurmas"
                v-model="matricula.turma"
                @change="(turma) => changeTurma(matricula, turma)"
                label="Selecione uma opção"
                :error-messages="errors"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="3">
            <ValidationProvider name="Ano" rules="required" v-slot="{ errors }">
              <e-label id="ano-label">Ano</e-label>
              <e-autocomplete
                id="ano-autocomplete"
                :items="matricula.turma ? matricula.turma.series : []"
                :return-object="false"
                :item-value="(serie) => serie.id"
                :item-text="(serie) => serie.descricao"
                :disabled="!matricula.turma"
                v-model="matricula.serie_id"
                label="Selecione uma opção"
                :error-messages="errors"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="1">
            <v-btn
              id="remove-matricula-btn"
              v-if="form.matriculas.length > 1"
              class="mt-8"
              color="error"
              @click="
                () =>
                  (form.matriculas = form.matriculas.filter(
                    (matriculaObj) => matriculaObj !== matricula
                  ))
              "
              small
              ><v-icon small>fa-trash</v-icon></v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="d-flex">
              <v-btn
                id="submit-matricula-btn"
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn
                id="add-matricula-btn"
                class="ml-3"
                v-if="!editing"
                color="secondary"
                @click="adicionarMatricula"
              >
                Adicionar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("Matriculas", ["matriculas", "carregandoMatriculas"]),
    // ...mapGetters("Alunos", ["alunosList", "carregandoAlunos"]),
    ...mapGetters("Turmas", ["turmasList", "carregandoTurmas"]),
    alunosDisponiveis() {
      return (currentIndex) => {
        const alunosSelecionados = this.form.matriculas
          .filter((_, index) => index !== currentIndex)
          .map((matricula) => matricula.aluno_id);
        return this.alunosList.filter((aluno) => !alunosSelecionados.includes(aluno.id));
      };
    },
  },
  mounted() {
    this.loadData();
    // this.loadFormData();
  },
  data() {
    return {
      submittingForm: false,
      form: {
        matriculas: [{ aluno_id: null, turma_id: null, turmaSelecionada: null, serie_id: null }],
      },
      series: [],
      alunosList: [],
      carregandoAlunos: false,
    };
  },
  methods: {
    // ...mapActions("Alunos", ["loadAlunos"]),
    ...mapActions("Turmas", ["loadTurmas"]),
    async changeTurma(matricula, turma) {
      try {
        await this.$services.turmasService.verificaCapacidadeTurma(turma.id);
        matricula.turma_id = turma.id;
        matricula.serie_id = turma.series[0].id;
      } catch (error) {
        this.$toast.danger(error);
        matricula.turma = null;
      }
    },
    adicionarMatricula() {
      this.form.matriculas.push({});
    },
    async submitForm() {
      this.form.especial = Boolean(this.form.especial);
      this.form.recursos_saeb = this.recursos_saeb;
      this.submittingForm = true;

      try {
        if (this.editing) {
          const m = this.form.matriculas[0];
          const payload = {
            ...m,
            turma_id: m.turma?.id ?? m.turma_id,
            serie_id: m.serie_id,
          };
          delete payload.turma;
          await this.$services.matriculasService.atualizarMatricula(payload);
          this.$toast.success("Matrícula atualizada com sucesso");
        } else {
          // mesma abordagem para criação
          const payload = this.form.matriculas.map((m) => ({
            aluno_id: m.aluno_id,
            turma_id: m.turma?.id ?? m.turma_id,
            serie_id: m.serie_id,
          }));

          await this.$services.matriculasService.matricular({ matriculas: payload });
          this.$toast.success("Matrícula(s) criada(s) com sucesso");
        }

        this.$router.push({ name: "matriculas" });
      } catch (error) {
        this.$handleError(error);
        if (error?.matricula_com_erro || error?.matriculas) {
          const novasMatriculas = (error.matriculas || [error.matricula_com_erro]).map(
            (matricula) => {
              const turma = this.turmasList.find((t) => t.id === matricula.turma_id);
              return {
                ...matricula,
                turma: turma || null,
              };
            }
          );

          this.form.matriculas.splice(0, this.form.matriculas.length, ...novasMatriculas);
          this.form.especial = error.especial ?? false;
        }
      }

      this.submittingForm = false;
    },

    async loadAlunos() {
      this.carregandoAlunos = true;
      try {
        this.alunosList = await this.$services.alunosService.syncAll();
      } catch (error) {
        this.$handleError(error);
      }
      this.carregandoAlunos = false;
    },
    async loadData() {
      try {
        if (this.alunosList.length === 0 || this.turmasList.length === 0) {
          this.$loaderService.open("Carregando dados");
        }
        await this.loadFormData();

        await Promise.all([this.loadTurmas(), this.loadAlunos()]);

        this.$loaderService.close();
        this.$forceUpdate();
        this.verificarPreSelecaoAluno();
        // this.loadFormData();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async loadFormData() {
      if (!this.matriculas || !this.editing) {
        if (!this.form.matriculas || this.form.matriculas.length === 0) {
          this.form = {
            matriculas: [
              { aluno_id: null, turma_id: null, turmaSelecionada: null, serie_id: null },
            ],
          };
        }
        return;
      }

      const { matricula_id } = this.$route.params;
      const matricula = await this.$services.matriculasService.getMatricula(matricula_id);

      if (matricula) this.form = { matriculas: [matricula] };
    },
    verificarPreSelecaoAluno() {
      if (this.editing) return;
      const alunoIdFromQuery = this.$route.query.aluno_id;
      if (!alunoIdFromQuery) return;
      const alunoId = parseInt(alunoIdFromQuery, 10);
      if (!alunoId || isNaN(alunoId)) {
        this.$toast.warning("ID de aluno(a) inválido na URL");
        return;
      }
      const alunoExiste = this.alunosList.find((aluno) => aluno.id === alunoId);
      if (!alunoExiste) {
        this.$toast.danger("Aluno(a) não encontrado(a)");
        return;
      }
      if (this.form.matriculas[0]) {
        this.$set(this.form.matriculas[0], "aluno_id", alunoId);
        this.$nextTick(() => {
          if (this.$refs.observer) {
            this.$refs.observer.validate();
          }
          this.$toast.info(`Aluno(a) "${alunoExiste.nomecompleto}" pré-selecionado(a)`);
        });
      }
    },
  },
};
</script>

<style></style>
